import {getEvents, getSaveChannels} from "../globalMethods/myConfig";

const getChannelsFromGenre = async (genreId) => {
    const actualTime = new Date().getTime()
    const events = await getEvents()
    const channels =  getSaveChannels()

    let foundChannels =  [ ]
    for (const channel of channels) {
        const myEvents = events.filter(event => event.id === parseInt(channel?.EpgId))
        if(myEvents.length === 1 ){
            const events = myEvents[0]?.events
            for (const myEvent of events) {
                const duration =  myEvent?.timecodes[0]?.duration
                const eventStartDate =  new Date(myEvent?.startDate)
                const endingDate = eventStartDate.getTime() + duration
                let startingDate = eventStartDate.getTime()
                if((startingDate < actualTime) && (endingDate > actualTime)){
                    if(myEvent?.genre === parseInt(genreId)) {
                        foundChannels.push(channel)
                        break
                    }
                }

            }
        }
    }
    return  foundChannels

}

export  {
    getChannelsFromGenre
}